import { useNavigate, useParams } from 'react-router-dom';
import Language_i18 from '../../js/useNationalLanguage.jsx';

function ProfileNav() {
    const { slug_2, slug_3 } = useParams();
    const navigate = useNavigate();

    const { i18n, lang } = Language_i18();

    // Đối tượng dịch thuật cho giao diện người dùng (ví dụ)
    const translations = {
        vi: {
            attendance: 'điểm danh',
            viewLink: 'xem link',
            p2p_mmo: 'p2p_mmo',
            tiktok: 'tiktok',
            referrals: 'thuê cày',
            otherJobs: 'jop khác'
        },
        en: {
            attendance: 'Check in',
            viewLink: 'Views Link',
            p2p_mmo: 'p2p_mmo',
            tiktok: 'TikTok',
            referrals: 'Referrals',
            otherJobs: 'Other Jobs'
        }
    };

    // Danh sách nút điều hướng
    const navItems = [
        {
            route: '/shop/p2p/mmo/cilent/rollup?app=showadview',
            key: 'attendance',
            match: 'rollup'
        },
        {
            route: '/shop/p2p/mmo/cilent/option_view?webappmode=showadview',
            key: 'viewLink',
            match: 'option_view'
        },
        {
            route: '/shop/p2p/mmo/cilent/p2p_mmo?webappmode=showadview',
            key: 'p2p_mmo',
            match: 'p2p_mmo'
        },
        {
            route: '/shop/jop/cheotiktok?showadview=true',
            key: 'tiktok',
            match: 'cheotiktok'
        },
        {
            route: '/shop/referrals/home',
            key: 'referrals',
            match: 'home'
        },
        {
            route: '/shop/main/menu?webappmode=showadview',
            key: 'otherJobs',
            match: 'menu'
        }
    ];

    return (
        <div className="flex justify-center mt-0 gap-2">
            {navItems.map((item) => {
                const isActive = (slug_3 || slug_2) === item.match;
                return (
                    <div
                        key={item.key}
                        className={`text-xs bg-purple-100 lg:text-base rounded-md border-2 cursor-pointer px-1 py-1 ${isActive ? 'border-pink-400' : 'border-green-200'
                            }`}
                        onClick={() => navigate(item.route)}
                    >
                        {translations[lang][item.key]}
                    </div>
                );
            })}
        </div>
    );
}

export default ProfileNav;
